<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "wowjs/css/libs/animate.css";
import "bootstrap/dist/css/bootstrap.css";
import "@/assets/css/fontawesome.min.css";
import "@/assets/js/bootstrap.min.js";
import "@/assets/js/fontawesome.min.js";
import "@/assets/css/style.css";
import "@/assets/css/responsive.css";

export default {
  name: "App",
  mounted() {
    let script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11402316293";
    script.async = true;
    document.head.appendChild(script);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue